import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import launchDarklyStatus from './launchDarklyStatus';
import teamTaken from './teamTaken';
import invitedUser from './invitedUser';
import signedUp from './signedUp';
import signUpInProgress from './signUpInProgress';
import signUpError from './signUpError';
import inviteResent from './inviteResent';
import inviteTokenExpired from './inviteTokenExpired';
import features from './features';
import existingUser from './existingUser';
import newTeam from './newTeam';
import passwordRecoveryTokenStatus from './passwordRecoveryTokenStatus';
import updatePasswordStatus from './updatePasswordStatus';
import MFAStatus from './MFAStatus';
import loggedIn from './loggedIn';
import loginError from './loginError';
import ssoLoginRequired from './ssoLoginRequired';
import emailVerified from './emailVerified';

export default history =>
  combineReducers({
    router: connectRouter(history),
    emailVerified,
    launchDarklyStatus,
    teamTaken,
    signedUp,
    signUpInProgress,
    signUpError,
    invitedUser,
    inviteResent,
    inviteTokenExpired,
    loggedIn,
    loginError,
    MFAStatus,
    passwordRecoveryTokenStatus,
    updatePasswordStatus,
    features,
    existingUser,
    newTeam,
    ssoLoginRequired
  });
